/*
 * Copyright (c) 2023. Haodong JU
 */

import IKDataEntity from '@/plugins/EntityFrameWork/IKDataEntity'
import { hillo } from 'hillo'
import dayjs from 'dayjs'
import Servant from '@/model/dataLayer/api/tableAndPerson/Servant'

const entity = {
  _action: {
    form: false
  },
  content: {
    form: false
  },
  extraId: {
    form: false
  },
  note: {
    form: false,
    tableConfig: {
      overwrite: true
    }
  },
  servantId: {
    type: IKDataEntity.Types.Option,
    formConfig: {
      type: {
        selectItems: async () => {
          const res = (await Servant.getList(true))
          return res
        }
      }
    }
  }
}

const config = {
  load: async function (filter) {
    let [fromDateTime, toDateTime] = filter[0].dateFilter
    if (fromDateTime === toDateTime) {
      toDateTime = dayjs(toDateTime).add(1, 'day').format('YYYY-MM-DD')
    }
    const res = (await hillo.get('AccessLog.php?op=queryOperationLog', {
      fromDateTime: fromDateTime + ' 04:00:00',
      toDateTime: toDateTime + ' 03:59:59',
      descending: 1
    })).content
    res.forEach(it => {
      it._action = it.action
    })
    return res
  },

  edit: function (item) {
    return hillo.post('AccessLog.php?op=editOperationLogNote', {
      ...item
    })
  }
}

export default IKDataEntity.ModelFactory(entity, config)
